// extracted by mini-css-extract-plugin
module.exports = {"_grey":"#555","BackToMain":"BackToMain_BackToMain__G8E4x","Link":"BackToMain_Link__35n--","Light":"BackToMain_Light__3Z691"};